module.exports = require('./helpers/bundle-url').getBundleURL('hstjT') + "phone-solid.1c6138d0.svg";